export const axiosBaseQuery =
    (api) =>
    async ({ url, method, data, params }) => {
        try {
            const response = await api({ url, method, data, params });
            return { data: response?.data };
        } catch (axiosError) {
            const err = axiosError;
            return {
                error: {
                    data: err.response?.data || err.message,
                    statusCode: err.response?.status || 500,
                },
            };
        }
    };
